const MAP = {
  light: {
    on: { width: 8, height: 8, borderRadius: '50%', background: '#e2a93b' },
    off: { width: 8, height: 8, borderRadius: '50%', background: 'rgba(255,255,255,0.18)' },
  },
  dark: {
    on: { width: 8, height: 8, borderRadius: '50%', background: '#e2a93b' },
    off: { width: 8, height: 8, borderRadius: '50%', background: 'rgba(255,255,255,0.18)' },
  },
  industry: {
    on: { width: 9, height: 9, background: 'var(--color-accent)' },
    off: { width: 9, height: 9, border: '1px solid var(--color-accent-500)', background: 'transparent' },
  },
}

export default function FrameDots({ total, index, goTo, theme = 'dark', className = '' }) {
  const m = MAP[theme] || MAP.dark
  return (
    <div className={`flex items-center gap-[7px] ${className}`}>
      {Array.from({ length: total }, (_, k) => (
        <span
          key={k}
          onClick={() => goTo(k)}
          style={{ display: 'inline-block', cursor: 'pointer', ...m[k === index ? 'on' : 'off'] }}
        />
      ))}
    </div>
  )
}
